import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useSubSite } from 'contexts/SubSiteContext';
import styles from './MerchantCard.module.css';

const MerchantCard = ({ merchant }) => {
  const { isSubSite, subSiteSlug } = useSubSite();
  const merchantUrl = isSubSite 
    ? `/${subSiteSlug}/commercants/${merchant.slug}` 
    : `/commercants/${merchant.slug}`;

  const thumbnailUrl = merchant.thumbnail 
    ? `${process.env.REACT_APP_MEDIA_BASE_URL}${merchant.thumbnail}`
    : '/images/default-merchant.jpg';

  const descriptionExcerpt = merchant.description
    ? merchant.description.replace(/<\/?[^>]+(>|$)/g, '').slice(0, 100) + '...'
    : 'Aucune description disponible.';

  return (
    <article className={styles.merchantCard}>
      <Link to={merchantUrl} className={styles.imageLink}>
        <figure className={styles.figure}>
          <img 
            src={thumbnailUrl} 
            alt={merchant.name}
            className={styles.image}
          />
        </figure>
      </Link>
      <div className={styles.content}>
        <h3 className={styles.title}>
          <Link to={merchantUrl}>{merchant.name}</Link>
        </h3>
        {merchant.location && (
          <p className={styles.location}>
            <svg className={styles.locationIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
            </svg>
            {merchant.location}
          </p>
        )}
        <p className={styles.description}>{descriptionExcerpt}</p>
        {merchant.types && merchant.types.length > 0 && (
          <ul className={styles.tagList}>
            {merchant.types.map(type => (
              <li key={type.id} className={styles.tag}>{type.name}</li>
            ))}
          </ul>
        )}
        <Link to={merchantUrl} className={styles.link}>
          En savoir plus →
        </Link>
      </div>
    </article>
  );
};

MerchantCard.propTypes = {
  merchant: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    description: PropTypes.string,
    thumbnail: PropTypes.string,
    location: PropTypes.string,
    types: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
};

export default MerchantCard;






